import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader.jsx';
import './AdminLayout.css';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle Screen Resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false); // Auto-close on mobile
      } else {
        setIsSidebarOpen(true); // Auto-open on desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="admin-root">
      
      {/* 1. SIDEBAR (Passed state to control width) */}
      <AdminSidebar isOpen={isSidebarOpen} isMobile={isMobile} closeMobile={() => setIsSidebarOpen(false)} />

      {/* 2. MAIN CONTENT WRAPPER */}
      <div className={`admin-main-wrapper ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        
        {/* Header (Contains Hamburger) */}
        <AdminHeader toggleSidebar={toggleSidebar} isOpen={isSidebarOpen} />

        {/* Dynamic Page Content (Where Category/Dashboard loads) */}
        <main className="admin-content-area">
          <Outlet /> 
        </main>

        {/* Footer for Admin */}
        <footer className="admin-footer">
          <p>&copy; 2026 Sohani Admin Panel. Designed and Developed With ❤️ by <a className="ftr-cpt-developer" target='_blank' href="https://dheersoftwaresolutions.com/" style={{color:'black',textDecoration:'none',fontWeight:'bold'}}>Dheer Software Solutions</a></p>
        </footer>

      </div>

      {/* Mobile Overlay (Only visible on mobile when menu is open) */}
      {isMobile && isSidebarOpen && (
        <div className="admin-mobile-overlay" onClick={() => setIsSidebarOpen(false)}></div>
      )}
    </div>
  );
};

export default AdminLayout;